var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"#76c8d4","cx":"120","cy":"120","r":"120","key":0}),React.createElement("polyline",{"fill":"none","stroke":"#ff7494","strokeWidth":"27.6","strokeLinecap":"round","strokeLinejoin":"round","points":"105 176.3 160.5 119 105 63","key":1})]);
}

Right.defaultProps = {"viewBox":"0 0 240 240","width":"32","height":"32"};

module.exports = Right;

Right.default = Right;
